export const listItemBaseSx = {
    cursor: 'pointer',
    '&:hover': {
        bgcolor: 'common.hover',
    },
};

export const selectedItemSx = {
    bgcolor: 'common.sidebar',
    '&:hover': {
        bgcolor: 'common.hover',
    },
};
